import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    redirectUrl: { type: String }
  }

  static targets = ['card']

  redirect (e) {
    if (e.target.closest('a, button, input, textarea, select, label')) return
    if (!this.redirectUrlValue) return

    window.location.href = this.redirectUrlValue
  }
}
